import { ApolloClient } from 'apollo-client'
import { ApolloLink } from 'apollo-link'
import { HttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import Vue from 'vue'
import VueApollo from 'vue-apollo'
import fetch from 'unfetch'

Vue.use(VueApollo)

const uri = `${process.env.VUE_APP_SERVER_URL}/graphql`

const httpLink = new HttpLink({ uri, fetch, credentials: 'include' })

const link = ApolloLink.from([httpLink])

export const apolloClient = new ApolloClient({
  link,
  cache: new InMemoryCache({
    addTypename: false,
  }),
  connectToDevTools: true,
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'network-only',
      errorPolicy: 'all',
    },
    query: {
      fetchPolicy: 'network-only',
      errorPolicy: 'all',
    },
    mutate: {
      errorPolicy: 'all',
    },
  },
})

export default new VueApollo({
  defaultClient: apolloClient,
})
